import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {getPhoneDataFromString} from "../../../form/utils/get_phone_data_from_string";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {initialEmptyApplicationValues} from "../../constants/form/application_form_fields";
import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {LeadFormPromotion} from "../lead_form/LeadFormPromotion";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

interface IProps extends Pick<ComponentProps<typeof LeadFormPromotion>, "onSubmitDraft"> {
    handleModalClose: () => void;
}

export const LeadFormModalPromotion = (props: IProps) => {
    const {handleModalClose, onSubmitDraft} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);
    const draft = useAppSelector((state) => state.mainLead.promotionLeadDraft);
    const {data: userProfile} = useGetUserProfileQuery();

    const defaultValues = useMemo<IApplicationFormValues>(() => {
        if (draft) {
            return {
                ...initialEmptyApplicationValues,
                ...draft
            };
        }

        return {
            ...initialEmptyApplicationValues,
            name: userProfile?.name || "",
            email: userProfile?.email || "",
            phone: userProfile?.phone ? getPhoneDataFromString(userProfile.phone) : initialEmptyApplicationValues.phone,
            marketing_email: userProfile?.email_marketing_consent || false,
            marketing_sms: userProfile?.phone_marketing_consent || false
        };
    }, [draft, userProfile]);

    return (
        <LeadFormModalWrapper handleModalClose={handleModalCloseWithTracking} title="Zapytaj dewelopera o pełną ofertę" titleClassName={titleStyle}>
            <LeadFormPromotion defaultValues={defaultValues} onSubmitDraft={onSubmitDraft} />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {getPhoneDataFromString} from "../../../form/utils/get_phone_data_from_string";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {initialEmptyApplicationValues} from "../../constants/form/application_form_fields";
import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {LeadFormPromotion} from "../lead_form/LeadFormPromotion";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

interface IProps extends Pick<ComponentProps<typeof LeadFormPromotion>, "onSubmitDraft"> {
    handleModalClose: () => void;
}

export const LeadFormModalPromotion = (props: IProps) => {
    const {handleModalClose, onSubmitDraft} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);
    const draft = useAppSelector((state) => state.mainLead.promotionLeadDraft);
    const {data: userProfile} = useGetUserProfileQuery();

    const defaultValues = useMemo<IApplicationFormValues>(() => {
        if (draft) {
            return {
                ...initialEmptyApplicationValues,
                ...draft
            };
        }

        return {
            ...initialEmptyApplicationValues,
            name: userProfile?.name || "",
            email: userProfile?.email || "",
            phone: userProfile?.phone ? getPhoneDataFromString(userProfile.phone) : initialEmptyApplicationValues.phone,
            marketing_email: userProfile?.email_marketing_consent || false,
            marketing_sms: userProfile?.phone_marketing_consent || false
        };
    }, [draft, userProfile]);

    return (
        <LeadFormModalWrapper handleModalClose={handleModalCloseWithTracking} title="Zapytaj dewelopera o pełną ofertę" titleClassName={titleStyle}>
            <LeadFormPromotion defaultValues={defaultValues} onSubmitDraft={onSubmitDraft} />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
